import { DocumentReference, ISoftDelete } from '@principle-theorem/shared';
import { IOrganisation } from '../organisation/organisation';
import { IUser } from '../user/user';
import { ApiWebhookEvent } from './webhook-event';
import { IPractice } from '../practice/practice';

export enum WebhookStatus {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export const WEBHOOK_STATUS_MAP: {
  [key in WebhookStatus]: string;
} = {
  [WebhookStatus.Enabled]: 'primary',
  [WebhookStatus.Disabled]: 'warn',
};

export enum WebhookDisabledReason {
  ConsecutiveFailures = 'consecutive_failures',
}

export interface IWebhook extends ISoftDelete {
  label: string;
  endpointUrl: string;
  secret: string;
  events: ApiWebhookEvent[];
  allowedPractices: DocumentReference<IPractice>[];
  status: WebhookStatus;
  organisationRef: DocumentReference<IOrganisation>;
  userRef?: DocumentReference<IUser>;
  /**
   * Number of consecutive failed webhook deliveries. Incremented on each
   * failure and reset to 0 on a successful delivery. When this reaches
   * `MAX_CONSECUTIVE_WEBHOOK_FAILURES`, the webhook is automatically
   * disabled. Optional for backwards compatibility with existing docs.
   */
  consecutiveFailures?: number;
  /**
   * Set to `WebhookDisabledReason.ConsecutiveFailures` when the webhook is
   * auto-disabled by the delivery pipeline. Absent (`undefined`) for
   * manual disables and for enabled webhooks. Cleared via
   * `FieldValue.delete()` when a webhook is re-enabled. Used by the write
   * triggers to distinguish auto-disable from manual disable when
   * deciding whether to email owners.
   */
  disabledReason?: WebhookDisabledReason;
}

export enum WebhookCollection {
  Events = 'webhookEvents',
}
